import { Grid } from "@mui/material";

type AlarmConsultRootProps = {
  children: React.ReactNode;
};

export function AlarmConsultRoot({ children }: AlarmConsultRootProps) {
  return <Grid container>{children}</Grid>;
}
